<template lang="pug">
    v-row
        v-col(cols="12") Участники проекта
        
        v-col(cols="12")
            v-row
                v-col(cols="12" xs="12" sm="6" md="4" lg="4")
                    v-card(flat)
                        a(href="https://vk.com/udmurtkenesh")
                            v-img.mb-5(alt="" class="shrink" contain src="/images/udmkenesh.jpg" transition="scale-transition" height="72" width="72")
                        div.member {{ "Main_MEMBERS_KENESH" | localize}}

                v-col(cols="12" xs="12" sm="6" md="4" lg="4")
                    v-card(flat)
                        a(href="https://f-uffu.udsu.ru")
                            v-img.mb-5(alt="" class="shrink" contain src="/images/uffu.jpg" transition="scale-transition" height="72" width="72")
                        div.member {{ "Main_MEMBERS_UFFU" | localize}}
                        

                v-col(cols="12" xs="12" sm="6" md="4" lg="4")
                    v-card(flat)
                        a(href="https://udmddn.ru")
                            v-img.mb-5(alt="" class="shrink" contain src="/images/ddn.png" transition="scale-transition" height="72" width="72")
                        div.member {{ "Main_MEMBERS_DDN" | localize}}

                v-col(cols="12" xs="12" sm="6" md="4" lg="4")
                    v-card(flat)
                        a(href="http://www.minnac.ru")
                            v-img.mb-5(alt="" class="shrink" contain src="/images/minnacpoludm.jpg" transition="scale-transition" height="72" width="72")
                        div.member {{ "Main_MEMBERS_MINNAC" | localize}}

                v-col(cols="12" xs="12" sm="6" md="4" lg="4")
                    v-card(flat)
                        a(href="https://www.myudm.ru")
                            v-img.mb-5(alt="" class="shrink" contain src="/images/myudmlogo.png" transition="scale-transition" height="72" width="72")
                        div.member {{ "Main_MEMBERS_UDMURTIA" | localize}}
        
</template>

<script>
    export default {

    }
</script>

<style lang="scss" scoped>
    .member {
        font-family: Segoe UI;
        font-style: normal;
        font-weight: normal;
        font-size: 19px;
        line-height: 22px;
        align-items: center;
        color: #000000;
    }
</style>